<template>
    <div class="cookies-wrapper" v-if="needCookieConsent">
        <div class="row center-xs middle-xs cookies-info">
            <div class="col-xs-7 col-sm-8 col-md-6 col-lg-6">
                <p>Este site utiliza cookies para permitir uma melhor experiência por parte do utilizador. Ao navegar no site estará a consentir a sua utilização.</p>
            </div>
            <div class="col-xs-5 col-sm-4 col-md-2 col-lg-2">
                <div class="row center-xs button-wrapper">
                    <div class="col-xs-6 col-sm-5 col-md-4 col-lg-3">
                        <button v-on:click="okCookies()">OK</button>
                    </div>
                    <div class="col-xs-6 col-sm-7 col-md-8 col-lg-6">
                        <button v-on:click="knowMoreCookies()">Ler Mais</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Cookies",
        data() {
          return {
              needCookieConsent: true,
              changedCookies: null
          }
        },
        watch: {
            'changedCookies': function () {
                this.needCookieConsent = !this.$cookies.get('acceptedCookies');
            }
        },
        mounted() {
            this.changedCookies = this.$cookies;
            this.needCookieConsent = !this.$cookies?.get('acceptedCookies');
        },
        methods: {
            okCookies() {
                this.$cookies.set('acceptedCookies', true);
                this.needCookieConsent = !this.$cookies.get('acceptedCookies');
            },
            knowMoreCookies() {
                this.$router.push(`/cookie-policy/4rixlqla9uYcjq1AYkcarH`).catch(() => {});
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/styles/global';

    .cookies-wrapper {
        height: 4em;
        position: fixed;
        bottom: 0;
        background-color: $bgcolor-grey;
        width: 100%;
        padding-top: 0.3em;
        padding-bottom: 0.3em;
        z-index: 99;

        .cookies-info {
            background-color: $primary;
            height: 100%;
            p {
                margin-block-start: 0em;
                margin-block-end: 0em;
                color: $bgcolor-grey;
                text-transform: uppercase;
                font-size: x-small;
                letter-spacing: 0.1em;
                font-weight: 600;
            }
        }
    }

    .button-wrapper {
        margin: 0.5em;
    }

    button {
        height: 2.5em;
        border: 0;
        width: 100%;
        background: $bgcolor-grey;
        color: $primary;
        text-transform: uppercase;
        font-size: x-small;
        letter-spacing: 0.1em;
        font-weight: 600;
        margin: 0.5em;
        cursor: pointer;

        &:hover {
            background: $primary;
            color: $bgcolor-grey;
            border-color: $bgcolor-grey;
            border-width: thin;
            border-style: solid;
        }
    }
</style>
